import { STATUS } from 'constants/checkout'
import {
  OnCheckoutDisabled,
  OnCheckoutError,
  OnCheckoutQueued,
  OnCheckoutRedirectionUrlFetched,
  OnCheckoutReset,
  OnCheckoutStatusChanged
} from './checkout.types'

export const CHECKOUT_RESET = 'CHECKOUT_RESET'
export const CHECKOUT_STATUS_CHANGED = 'CHECKOUT_STATUS_CHANGED'

export const onCheckoutDisabled: OnCheckoutDisabled = response => ({
  payload: { response, status: STATUS.ERROR },
  type: CHECKOUT_STATUS_CHANGED
})

export const onCheckoutError: OnCheckoutError = error => ({
  payload: { error, status: STATUS.ERROR },
  type: CHECKOUT_STATUS_CHANGED
})

export const onCheckoutQueued: OnCheckoutQueued = response => ({
  payload: { response, status: STATUS.QUEUED },
  type: CHECKOUT_STATUS_CHANGED
})

export const onCheckoutRedirectionUrlFetched: OnCheckoutRedirectionUrlFetched = response => ({
  payload: { response, status: STATUS.REDIRECTING },
  type: CHECKOUT_STATUS_CHANGED
})

export const onCheckoutReset: OnCheckoutReset = () => ({
  type: CHECKOUT_RESET
})

export const onCheckoutStatusChanged: OnCheckoutStatusChanged = status => ({
  payload: { status },
  type: CHECKOUT_STATUS_CHANGED
})
